import * as React from 'react';
import { ConversationDetailsType } from '../types/ConversationType';
import TranslationService from '../../../core/services/TranslationService';
import { ModuleNamesList } from '../../../core/lists/ModuleNamesList';
import { NavLink } from 'react-router-dom';

export interface IDebtorDetailsProps {
  conversationDetails: ConversationDetailsType;
}

class DebtorDetails extends React.Component<IDebtorDetailsProps> {
  public render() {
    return (
      <div className="debtor-details-container m-2">
        <dl className="row mb-0">
          <dt className="col-4 text-nowrap">
            {TranslationService.translateModule('Debtor', ModuleNamesList.Messages)}
          </dt>
          <dd className="col-8 text-nowrap">{this.getDebtorDetails()}</dd>

          <dt className="col-4 text-nowrap">
            {TranslationService.translateModule('CaseNr', ModuleNamesList.Messages)}
          </dt>
          <dd className="col-8 text-nowrap">{this.getCaseDetails()}</dd>

          <dt className="col-4 text-nowrap">
            {TranslationService.translateModule('Creditor', ModuleNamesList.Messages)}
          </dt>
          <dd className="col-8 text-nowrap">{this.getCreditorDetails()}</dd>
        </dl>
      </div>
    );
  }

  private getCaseDetails = () => {
    const link = `case?id=${this.props.conversationDetails.caseDetails.caseNumber}`;
    const hasData =
      (this.props.conversationDetails.caseDetails.caseNumber &&
        this.props.conversationDetails.caseDetails.caseNumber.trim() !== '') ||
      (this.props.conversationDetails.caseDetails.referenceNumber &&
        this.props.conversationDetails.caseDetails.referenceNumber.trim() !== '');
    return hasData ? (
      <NavLink id="caseNumberLink" to={link} className="font-weight-bold">
        {this.props.conversationDetails.caseDetails.caseNumber.trim()}{' '}
        {this.props.conversationDetails.caseDetails.referenceNumber !== '' ? '/' : ''}{' '}
        {this.props.conversationDetails.caseDetails.referenceNumber}
      </NavLink>
    ) : (
      ''
    );
  };

  private getCreditorDetails = () => {
    return (
      <>
        {this.props.conversationDetails.caseDetails.creditor.name}{' '}
        {this.props.conversationDetails.caseDetails.creditor.number !== '' ? '/' : ''}{' '}
        {this.props.conversationDetails.caseDetails.creditor.number}
      </>
    );
  };

  private getDebtorDetails = (): string => {
    return `${this.props.conversationDetails.debtor.firstName} ${this.props.conversationDetails.debtor.lastName} / ${this.props.conversationDetails.debtor.number}`;
  };
}

export default DebtorDetails;
